import { FormClassRetire } from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const infoHeadTitleList: any[] = [
  {
    headTitle: "決裁日",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
];

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLW410006_01,
    explanatoryTextRule: "\\n",
  },
  {
    title: "退職者名",
    keyword: "retireStaffName",
    type: "text",
    text: "",
  },
  {
    title: "金融機関コード",
    keyword: "bBankCd",
    type: "text",
    text: "",
  },
  {
    title: "金融機関名",
    keyword: "bBankName",
    type: "text",
    text: "",
  },
  {
    title: "支店コード",
    keyword: "bBranchCd",
    type: "text",
    text: "",
  },
  {
    title: "支店名",
    keyword: "bBranchName",
    type: "text",
    text: "",
  },
  {
    title: "口座番号",
    keyword: "bAccountNo",
    type: "text",
    text: "",
  },
  {
    title: "口座名義",
    keyword: "bAccountHolderKana",
    type: "text",
    text: "",
  },
  {
    keyword: "break",
    type: "lineTitle",
  },
  {
    title: "振込先金融機関",
    keyword: "financialInstitution",
    type: "bankSearch",
    buttonDisabled: true,
    requiredIcon: true,
    helpicon: true,
    helpText:
      "退職手当金を振込金融機関を「振込先金融機関登録」ボタンを押して選択してください。",
  },
  {
    title: "金融機関コード",
    keyword: "aBankCd",
    type: "text",
    text: "",
    requiredIcon: true,
  },
  {
    title: "金融機関名",
    keyword: "aBankName",
    type: "text",
    text: "",
    requiredIcon: true,
  },
  {
    title: "支店コード",
    keyword: "aBranchCd",
    type: "text",
    text: "",
    requiredIcon: true,
  },
  {
    title: "支店名",
    keyword: "aBranchName",
    type: "text",
    text: "",
    requiredIcon: true,
  },
  {
    title: "口座番号",
    keyword: "aAccountNo",
    type: "text",
    text: "",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "退職手当金振込先金融機関の口座番号です。7桁の番号をご入力ください。6桁の場合は、口座番号の前「0」をつけて入力してください。",
  },
  {
    title: "口座名義人名（半角ｶﾀｶﾅ）",
    keyword: "aAccountHolderKana",
    type: "text",
    text: "",
    requiredIcon: true,
    useFurigana: true,
    convertToHalfwidth: true,
    hafWidth: true,
    helpicon: true,
    helpText:
      "退職手当金振込先金融機関の口座名義（フリガナ）を入力してください。",
  },
  {
    title: "振込先金融口座が確認できる書類",
    keyword: "bankChangeFileName",
    type: "downloadLink",
    requiredIcon: true,
    downloadBase64: true,
    id: FormClassRetire["振込先金融口座が確認できる書類"],
  },
  {
    title: "氏名が変更されていることを確認できる書類",
    keyword: "changedNameDocument",
    type: "downloadLink",
    downloadBase64: true,
    id: FormClassRetire["氏名が変更されていることを確認できる書類"],
  },
];

const schema = {
  aAccountNo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "7"),
    },
    maxLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "7"),
    },
  },
  aAccountHolderKana: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[ｧ-ﾝﾞﾟ\s-]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0054E"),
    },
    minLength: {
      value: 1,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "1"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  memo: {
    maxLength: {
      value: 500,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "500"),
    },
  },
};

export { fakeTableList, schema, infoHeadTitleList };
